import { createSelector } from '@reduxjs/toolkit';
import { selectIsNotLastFloor } from 'shared/selectors/jsonQuery';

export const selectIsNotLastFloorFilter = createSelector(selectIsNotLastFloor, value => ({
  label: 'Не последний',
  value: Boolean(value),
}));
